import { DeviceType } from '../details/types';
import type { TelematicsTile } from './configuration/types';

export const isPocketDriverRegistrationMaintenanceActive = (
    selectedTelematics: TelematicsTile | undefined,
    maintenanceEnabled: boolean
) => maintenanceEnabled && selectedTelematics?.deviceType === DeviceType.POCKET_DRIVER_APP;
